import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';


import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import {
  AgmCoreModule
} from '@agm/core';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

// 
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { TablesComponent } from './crud/table/table.component';
import { TablaComponent } from './crud/tabla/tabla.component';
import { FormularioComponent } from './crud/formulario/formulario.component';
import { FormComponent } from './crud/form/form.component';
import { EditComponent } from './crud/onlyedit/form.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { LoginComponent } from './login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { EvaluacionesComponent } from './evaluaciones/evaluaciones.component';
import { EjecucionesComponent } from './ejecuciones/ejecuciones.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    // ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
    FormsModule,
    NgxDatatableModule,
    DropzoneModule,
    SweetAlert2Module.forRoot(),
    NgbModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    NgSelectModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    TablesComponent,
    TablaComponent,
    FormularioComponent,
    FormComponent,
    EditComponent,
    LoginComponent,
    EvaluacionesComponent,
    EjecucionesComponent,

  ],
  providers: [BsModalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
